import { Routes } from '@angular/router';

export const pimsRoutes: Routes = [
    { path: '', redirectTo: 'producer-enterprises', pathMatch: 'full' },
    {
        path: 'producer-enterprises',
        loadComponent: () =>
            import('./producer-enterprises/producer-enterprises.component').then((m) => m.ProducerEnterprisesComponent),
    },
    {
        path: 'product-details/:peId',
        loadComponent: () =>
            import('./product-details/product-details.component').then((m) => m.ProductDetailsComponent),
    },
    {
        path: 'product-details/:peId/product',
        loadComponent: () => import('./create-product/create-product.component').then((m) => m.CreateProductComponent),
        children: [
            { path: '', redirectTo: 'add-product', pathMatch: 'full' },
            {
                path: 'add-product',
                data: { label: 'addProduct' },
                loadComponent: () =>
                    import('./create-product/add-product/add-product.component').then((m) => m.AddProductComponent),
            },
            {
                path: 'assessment',
                data: { label: 'assessment' },
                loadComponent: () =>
                    import('./create-product/assessment/assessment.component').then((m) => m.AssessmentComponent),
            },
            {
                path: 'eligibility-result',
                data: { label: 'eligibilityResult' },
                loadComponent: () =>
                    import('./create-product/eligibility-result/eligibility-result.component').then(
                        (m) => m.EligibilityResultComponent,
                    ),
            },
        ],
    },
];
